import { render, staticRenderFns } from "./open-questions.vue?vue&type=template&id=1ebbe414&scoped=true&"
import script from "./open-questions.vue?vue&type=script&lang=js&"
export * from "./open-questions.vue?vue&type=script&lang=js&"
import style0 from "./open-questions.vue?vue&type=style&index=0&id=1ebbe414&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ebbe414",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1ebbe414')) {
      api.createRecord('1ebbe414', component.options)
    } else {
      api.reload('1ebbe414', component.options)
    }
    module.hot.accept("./open-questions.vue?vue&type=template&id=1ebbe414&scoped=true&", function () {
      api.rerender('1ebbe414', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/aawz-intelligence-v2/components/open-questions/open-questions.vue"
export default component.exports